import VSelect from './VSelect'

VSelect.install = function install (Vue) {
  Vue.component(VSelect.name, VSelect)
}

export default VSelect



// WEBPACK FOOTER //
// ./src/components/VSelect/index.js